"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ViewWork_1 = __importDefault(require("@Components/ViewWork"));
const react_1 = __importStar(require("react"));
const contexts_1 = require("@App/contexts");
const lodash_1 = require("lodash");
const ViewWorkHeader_1 = __importDefault(require("@Components/ViewWork/Headers/ViewWorkHeader"));
const WizardStepHeading_1 = __importDefault(require("@Components/WizardFlow/WizardStepHeading"));
const existing_work_schema_1 = __importDefault(require("@Entities/schemas/work/existing-work-schema"));
const work_schema_1 = __importDefault(require("@Entities/schemas/work/work-schema"));
const ReviewWorkFormScene = ({ workType, showHeader }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    const { workStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const [errors, setErrors] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        var _a;
        const workSchemaToUse = ((_a = workStore.workDraftLocal) === null || _a === void 0 ? void 0 : _a.isComplete) ? existing_work_schema_1.default : work_schema_1.default;
        const results = workSchemaToUse.safeParse(workStore.workDraftLocal);
        if (!results.success) {
            setErrors(results.error.format());
        }
        workStore.setWizardStepValidation(results.success);
    }, []);
    const isClaimWork = workType === 'claim-wizard';
    // Only show newly-added alternative titles & recordings, except on drafts
    const altTitles = workType === 'draft'
        ? (_b = (_a = workStore.workDraftLocal) === null || _a === void 0 ? void 0 : _a.alternativeTitles) !== null && _b !== void 0 ? _b : []
        : (0, lodash_1.difference)((_d = (_c = workStore.workDraftLocal) === null || _c === void 0 ? void 0 : _c.alternativeTitles) !== null && _d !== void 0 ? _d : [], (_f = (_e = workStore.workById) === null || _e === void 0 ? void 0 : _e.alternativeTitles) !== null && _f !== void 0 ? _f : []);
    const recordings = workType === 'draft'
        ? (_h = (_g = workStore.workDraftLocal) === null || _g === void 0 ? void 0 : _g.recordings) !== null && _h !== void 0 ? _h : []
        : (0, lodash_1.difference)((_k = (_j = workStore.workDraftLocal) === null || _j === void 0 ? void 0 : _j.recordings) !== null && _k !== void 0 ? _k : [], (_m = (_l = workStore.workById) === null || _l === void 0 ? void 0 : _l.recordings) !== null && _m !== void 0 ? _m : []);
    return workStore.workDraftLocal ? (react_1.default.createElement(react_1.default.Fragment, null,
        showHeader && react_1.default.createElement(ViewWorkHeader_1.default, { work: workStore.workDraftLocal, errors: errors }),
        workType === 'create-wizard' && (react_1.default.createElement(WizardStepHeading_1.default, { heading: 'Review', title: (_o = workStore.workDraftLocal) === null || _o === void 0 ? void 0 : _o.title },
            react_1.default.createElement(react_1.default.Fragment, null,
                "Please review the information you have entered for this work. If you need to edit any information, click the ",
                react_1.default.createElement("strong", null, "Edit"),
                " button. Once all information is correct, click the",
                ' ',
                react_1.default.createElement("strong", null, "Submit"),
                " button."))),
        isClaimWork && (react_1.default.createElement(WizardStepHeading_1.default, { heading: 'Review', title: (_p = workStore.workDraftLocal) === null || _p === void 0 ? void 0 : _p.title },
            react_1.default.createElement(react_1.default.Fragment, null,
                "Review your information before making a claim. If you would like to make any edits go back to the section you would like to update. If you are satisfied with this information, press the",
                ' ',
                react_1.default.createElement("strong", null, "Claim"),
                " button."))),
        react_1.default.createElement(ViewWork_1.default, { viewWork: Object.assign(Object.assign({}, workStore.workDraftLocal), { alternativeTitles: altTitles, recordings: recordings }), workErrors: errors, editing: !isClaimWork, workType: workType }))) : null;
};
exports.default = ReviewWorkFormScene;
